import { BilingualFallbackType } from "../../../shared/types/bilingual-fallback-type";

export const BILINGUAL_FALLBACK_OPTIONS = [
    {
        label: 'bilingual.fallback.native.label',
        value: BilingualFallbackType.NATIVE
    },
    {
        label: 'bilingual.fallback.cancel.label',
        description: 'bilingual.fallback.cancel.description',
        value: BilingualFallbackType.BILINGUAL
    }
];


// WEBPACK FOOTER //
// ./ts/app/shared/teacher-switch/consts/bilingual-fallback-options.ts